function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { createColorStack, finalizeColorStack } from "../colorStack/colorStack";
import { standardLabels, standardDefinitions } from "../standardColors/standardColors";
import { createAccessoryPaletteFromSeed } from "../colorFromSeed/colorFromSeed";
import chroma from "chroma-js";
export function createColorPalette() {
    for(var _len = arguments.length, stacksAndConstructors = new Array(_len), _key = 0; _key < _len; _key++){
        stacksAndConstructors[_key] = arguments[_key];
    }
    var stacks = stacksAndConstructors.reduce(function(acc, stackOrConstructor) {
        if (Array.isArray(stackOrConstructor)) {
            if (stackOrConstructor[1] === 'seed' && chroma.valid(stackOrConstructor[0])) {
                var createdAccessoryPalette = createAccessoryPaletteFromSeed(stackOrConstructor[0]);
                if (typeof createdAccessoryPalette === 'undefined' || createdAccessoryPalette === null) {
                    return acc;
                }
                return _toConsumableArray(acc).concat(_toConsumableArray(createdAccessoryPalette.colorStacks.filter(function(stack) {
                    return typeof stack !== 'undefined';
                })));
            }
            if (stackOrConstructor[1] !== 'seed') {
                var createdStack = createColorStack.apply(void 0, _toConsumableArray(stackOrConstructor));
                if (typeof createdStack === 'undefined') {
                    return acc;
                }
                return _toConsumableArray(acc).concat([
                    createdStack
                ]);
            }
            return acc;
        }
        return _toConsumableArray(acc).concat([
            stackOrConstructor
        ]);
    }, []);
    var presentStackLabels = stacks.reduce(function(accumulator, stack) {
        return stack.label ? accumulator.concat(stack.label) : accumulator;
    }, []);
    var stacksWithStandardStacks = _toConsumableArray(stacks);
    Object.values(standardLabels).forEach(function(label) {
        if (presentStackLabels.includes(label)) {
            return;
        }
        var createdStack = createColorStack.apply(void 0, _toConsumableArray(standardDefinitions[label]));
        if (typeof createdStack !== 'undefined') {
            stacksWithStandardStacks.push(createdStack);
        }
    });
    return stacksWithStandardStacks;
}
export default createColorPalette;
export function finalizeColorPalette(palette) {
    var simplifiedDefault = {};
    var simplifiedDark = {};
    palette.forEach(function(stack) {
        if (Array.isArray(stack.label)) {
            stack.label.forEach(function(label) {
                var ref = finalizeColorStack(_objectSpread({}, stack, {
                    label: label
                })), defaultStack = ref.default, darkStack = ref.dark;
                simplifiedDefault[label] = defaultStack;
                simplifiedDark[label] = darkStack;
            });
        } else {
            var ref1 = finalizeColorStack(stack), defaultStack1 = ref1.default, darkStack1 = ref1.dark;
            simplifiedDefault[stack.label] = defaultStack1;
            simplifiedDark[stack.label] = darkStack1;
        }
    });
    return {
        default: simplifiedDefault,
        dark: simplifiedDark
    };
}
